import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import PropTypes from 'prop-types';
import React from 'react';
import Layout from '@4c/layout';

import Footer from './Footer';
import ErrorSegment from './ErrorSegment';
import Navbar from './Navbar';
import captureException from '../utils/captureException';

const styles = require('./PageRoot-styles.module.scss');
const propTypes = {
  className: PropTypes.string,
};

class PageRoot extends React.Component {
  state = { errored: false };

  componentDidCatch(error, errorInfo) {
    this.setState({ errored: true });

    captureException(error, { extra: errorInfo });
  }

  render() {
    const { className, children, noFooter, ...props } = this.props;
    return (
      <Layout
        direction="column"
        className={classNames(className, styles.root)}
        {...props}
      >
        <Navbar />
        <Layout
          id="page-content"
          as="main"
          direction="column"
          grow
          className={styles.main}
        >
          {this.state.errored ? <ErrorSegment /> : children}
        </Layout>
        {!noFooter && <Footer />}
      </Layout>
    );
  }
}
PageRoot.propTypes = propTypes;

export default PageRoot;
